import { Component, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-logout-dialog',
  templateUrl: './logout-dialog.component.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  styleUrls: ['./logout-dialog.component.scss']
})
export class LogoutDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<LogoutDialogComponent>) { }

  ngOnInit() {
  }
  onConfirm(): void {
    this.dialogRef.close(true); // Return true to indicate confirmation
  }

  onCancel(): void {
    this.dialogRef.close(false); // Return false to indicate cancellation
  }
}
